export enum FileStage {
  DRAFT = 'DRAFT',
  SIGNING = 'SIGNING',
  FINISH = 'FINISH',
}
